import { useState } from 'react';
import { cn } from '../lib/cn.js';
import { Input, type InputProps } from './Input.js';

export type PasswordInputProps = Omit<InputProps, 'type'>;

/** Password field with an accessible show/hide control (labels stay on FormField). */
export function PasswordInput({ className, id, disabled, ...props }: PasswordInputProps) {
  const [visible, setVisible] = useState(false);
  const inputId = id ?? props.name;

  return (
    <div className="relative w-full">
      <Input
        {...props}
        id={inputId}
        type={visible ? 'text' : 'password'}
        className={cn('pr-[4.75rem]', className)}
        disabled={disabled}
      />
      <button
        type="button"
        className={cn(
          'absolute inset-y-0 right-0 flex min-h-target items-center px-sm',
          'text-body-sm font-medium text-muted hover:text-default',
          'focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-focus',
          'disabled:cursor-not-allowed disabled:opacity-50',
        )}
        onClick={() => setVisible((current) => !current)}
        aria-label={visible ? 'Hide password' : 'Show password'}
        aria-pressed={visible}
        aria-controls={inputId}
        disabled={disabled}
      >
        {visible ? 'Hide' : 'Show'}
      </button>
    </div>
  );
}
